import React from 'react';
import { Sparkles, ShieldCheck, Microscope } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const ExoticCarePage = () => {
  const config = {
    badge: "Exotic Specialist",
    headline: "Exotic Pet",
    headlineItalic: "Healthcare.",
    subtext: "Dedicated specialist care for non-traditional pets requiring species-specific medical knowledge and handling expertise.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Exotic Animal Care at Dr. Suresh Pet Care — Specialist Healthcare",
    stats: [
      { value: 400, suffix: '+', label: 'Exotic Cases Treated' },
      { value: 15, suffix: '+', label: 'Species Categories' },
      { value: 5, suffix: '+', label: 'Years Expertise' },
      { value: 24, suffix: '/7', label: 'Emergency Care' },
    ],
    services: [
      {
        title: "Avian Medicine",
        icon: <Sparkles size={28} />,
        desc: "Comprehensive care for pet birds including parrots, cockatiels, and finches with species-specific protocols.",
        specs: ["Beak & Nail Trimming", "Bacterial Cultures", "Nutritional Counseling", "Respiratory Care"],
        color: "from-yellow-500/10 to-primary/10"
      },
      {
        title: "Reptile Healthcare",
        icon: <ShieldCheck size={28} />,
        desc: "Specialized care for tortoises, geckos, and snakes with environment-specific health protocols.",
        specs: ["Metabolic Bone Disease", "Parasite Screening", "Husbandry Guidance", "Shell Repair"],
        color: "from-primary/10 to-green-500/10"
      },
      {
        title: "Small Mammal Care",
        icon: <Microscope size={28} />,
        desc: "Medical and surgical care for rabbits, guinea pigs, ferrets, and hedgehogs with specialist protocols.",
        specs: ["Dental Malocclusion", "GI Stasis Treatment", "Neutering", "Respiratory Conditions"],
        color: "from-orange-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Exotic",
    sectionItalic: "Capabilities.",
    warningTitle: "Exotic Pet",
    warningItalic: "Warning Signs.",
    warningText: "Exotic animals often mask illness instinctively. Understanding species-specific warning signs allows for early and effective intervention.",
    warnings: [
      { name: "Appetite Loss", desc: "Refusal to eat for 24+ hours is a serious sign in most exotic species.", icon: "🦎" },
      { name: "Lethargy & Inactivity", desc: "Unusual stillness or reduced activity can signal systemic illness.", icon: "🐢" },
      { name: "Breathing Difficulty", desc: "Open-mouth breathing or tail-bobbing indicates a respiratory emergency.", icon: "🦜" },
      { name: "Discoloration", desc: "Skin, scale, or feather color changes often signal disease or stress.", icon: "🌈" },
    ],
    ctaBadge: "Exotic Specialist",
    ctaTitle: "The Exotic Care",
    ctaItalic: "Expertise.",
    ctaText: "Our exotic animal specialists bring species-level knowledge and compassionate handling to every non-traditional patient in Hyderabad.",
    ctaBtn: "Book Exotic Consult",
    seoText: "Expert exotic animal care in Hyderabad. Specialist treatment for birds, reptiles, and small mammals at Dr. Suresh Pet Care.",
    glowColor: "yellow-500"
  };

  return (
    <>
      <SEO 
        title="Exotic Animal & Specialist Care"
        description="Specialist veterinary care for exotic pets including reptiles, birds, and small mammals at Dr. Suresh Pet Care, Hyderabad."
        canonical="/exotic-care"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default ExoticCarePage;
